import { TakePosition } from "../../app/slices/EnvironmentSlice";
import { Actor } from "../../models/Actor";
import Take3D from "../../models/Take3D";

/**
 * Locations whose positions are folded away: everything except the selected
 * take's own location and the ones the user unfolded by hand.
 */
export function getCollapsedTakeLocationIds(
  takePositions: Pick<TakePosition, "id">[],
  currentTakeLocationId: string | undefined,
  expandedTakeLocationIds: string[]
): string[] {
  return takePositions
    .filter(
      (point) =>
        point.id !== currentTakeLocationId &&
        !expandedTakeLocationIds.includes(point.id)
    )
    .map((point) => point.id);
}

/** Number of positions a collapsed location pin stands in for. */
export function countTakeLocationPositions(point: TakePosition): number {
  return (
    (point.actor_positions?.length ?? 0) +
    (point.prop_positions?.length ?? 0) +
    (point.allow_situation ? 1 : 0)
  );
}

/**
 * Actors of the take that stand on one of this location's positions, including
 * positions of a situation placed at the location (`<situationId>/<positionId>`).
 */
export function getActorsPlacedAtTakeLocation(
  point: TakePosition,
  take: Pick<Take3D, "actors" | "situations"> | undefined,
  actors: Actor[]
): Actor[] {
  if (!take) return [];

  const positionIds = new Set(
    (point.actor_positions ?? []).map((position) => position.id)
  );
  const situationId = take.situations?.[point.id];

  return take.actors
    .filter(
      (state) =>
        positionIds.has(state.positionId) ||
        (!!situationId && state.positionId.startsWith(situationId + "/"))
    )
    .map((state) => actors.find((actor) => actor.id === state.actorId))
    .filter((actor): actor is Actor => actor !== undefined);
}
